import type { MapSource } from '../map';
import { ZOMBIE_ARENAS } from './zombie-farm';

/**
 * Willow Bend, a Zombie Nights map (ADR-0176): one long road. The dead come down it from the north graveyard, round two
 * bends to the Greenhouse's plaza, through the gap in its garden wall (the north door). Halfway along it loops up round
 * the willow pond: ten cells longer, so the dead take the straight unless it costs them more (two rows of fences across
 * it do: `BuildDef.pathCost`). From night 9 a back road opens from the south-west graveyard, short and straight in. Where
 * along the road a tower stands is the map's question: a bend's inside covers both its stretches. The arenas under it
 * are every zombies map's (`ZOMBIE_ARENAS`).
 */
export const WILLOW_BEND: MapSource = {
  id: 'willow-bend',
  name: 'Long Way Round',
  // Drawn in the village packs, as the battle royale's Village is (ADR-0206).
  style: 'village',
  rows: `
    ############################################################
    #.................:::......................................#
    #................:::::.....................................#
    #................::Z::.....................................#
    #................:::::............T........................#
    #.................:::......................................#
    #.......#####.....::....#######.............T..............#
    #.......#####.....::....#######.................,..........#
    #.................::..........................,,,,,........#
    #.................::................o........,,,,,,,.......#
    #.................::.........................,,,,,,,.......#
    #.................::.........................,,,,,,,.......#
    #...T.............::..........................,,,,,........#
    #.................::............................,..........#
    #...........o.....::...................................T...#
    #.................::......:::::::::::......................#
    #.................::......:::::::::::......................#
    #.................::......::T.~~~..::......................#
    #.................::......::.~~~~~.::......................#
    #.................::......::.~~~~~T::......................#
    #.....T...........::::::::::::::::::::::::::...............#
    #.................::::::::::::::::::::::::::...............#
    #.........................................::........o......#
    #........,................................::...............#
    #......,,,,,..............................::............T..#
    #.....,,,,,,,.............................::...............#
    #.....,,,,,,,.............................::..o............#
    #.....,,,,,,,.................::::::::::::::...............#
    #......,,,,,..................::::::::::::::...............#
    #........,....................::...........................#
    #...T...........T.......o.....::...........................#
    #.............................::...........................#
    #....................#######..::..######......T..T..T......#
    #....................#######..::..######...................#
    #.............................::...........................#
    #.............................::..............T..T..T......#
    #.....o.......................::...........................#
    #.............................::...........................#
    #.........T..................b==b.............T..T..T......#
    #...........................======.........................#
    #..................:::::::::==BB==...............,,,.......#
    #..................:::::::::==BB==.............,,,,,,,.....#
    #..................::.......======............,,,,,,,,,....#
    #..................::........bb=b.............,,,,,,,,,....#
    #.............o....::.........................,,,,,,,,,....#
    #..................::.........................,,,,,,,,,....#
    #.########.........::.T.......................,,,,,,,,,....#
    #.########.........::..........................,,,,,,,.....#
    #..................::............................,,,.......#
    #..................::......................................#
    #..................::...###...........o....................#
    #..................::...###................................#
    #...:::............::...###...........................T....#
    #..::::::::::::::::::...###................................#
    #..::Z:::::::::::::::...###.................T..............#
    #..:::::................###................................#
    #...:::.................###.........T......................#
    #..........................................................#
    #..........................................................#
    ############################################################
  `,
  arenas: ZOMBIE_ARENAS,
  // The north graveyard from night 1, the back road from night 9 (the Thresher's).
  gateNights: [1, 9],
  signs: [
    { cx: 29, cy: 29, gate: 0 },
    { cx: 41, cy: 22, gate: 0 },
    { cx: 17, cy: 51, gate: 1 },
  ],
  // Chomper (ADR-0180, ADR-0186): in from the edge, careening round the whole yard (all four quarters, out towards the
  // corners, through the plaza, crossing its own way) as if it had lost its mind, out again the way it came.
  chomper: {
    route: [
      [62, 40],
      [46, 40],
      [46, 48],
      [55, 48],
      [55, 57],
      [28, 57],
      [28, 45],
      [13, 45],
      [13, 22],
      [3, 22],
      [3, 9],
      [23, 9],
      [23, 5],
      [42, 5],
      [42, 12],
      [54, 12],
      [54, 21],
      [33, 21],
      [33, 46],
      [27, 46],
      [27, 37],
      [36, 37],
      [36, 40],
      [62, 40],
    ],
  },
};
